import BookNowModal from './BookNowModal';

export default BookNowModal;
